var login = {
  translation: {
    common: {
      accept: 'Přijmout',
      alreadyUser: 'Již máte účet?',
      and: 'a',
      backToLogin: 'Zpět na přihlašovací stránku',
      continueWith: 'Pokračovat s {{provider}}',
      createAccount: 'Vytvořit účet',
      createYourAccount: 'Vytvořte si účet',
      emailOrUsername: 'E-mail nebo uživatelské jméno',
      login: 'Přihlásit se',
      logIn: 'Přihlásit se',
      logInToBoards: 'Přihlásit se',
      newToBoards: 'Nový v Viki Teams?',
      pageNotFound_title: 'Stránka nenalezena',
      password: 'Heslo',
      privacyPolicy: 'Zásady ochrany osobních údajů',
      register: 'Registrovat',
      registerWithGoogle: 'Registrovat přes Google',
      termsOfService: 'Podmínky služby',
      togglePasswordVisibility: 'Zobrazit/skrýt heslo',
    },
  },
};

export { login as default };
